import { STORY_PIPELINE, STORY_TRANS_PIPELINE, generateRulesFromPipeline, } from './pipeline';
export { STORY_PIPELINE, STORY_TRANS_PIPELINE, PIPELINES, generateRulesFromPipeline, generatePipelineRoutes, getPipelineForEntityType, getPipelinePhaseOrder, derivePipelinePhase, computeFrontStep, computeReleaseStatus, getDownstreamSteps, getRegenerationPlan, FIELD_TIMESTAMPS, resolveStepNeeds, resolveStepNeedsForEntity, isStepStale, isFieldEmpty, isFieldPopulated, } from './pipeline';
export const STORY_TRANS_PHASE_CONFIG = {
    META_READY: {
        id: 'META_READY',
        label: 'Meta Ready',
        emoji: '🌱',
        color: 'warning',
        description: 'Metadata is ready - awaiting announce generation',
        isProcessing: false,
        isFinal: false,
    },
    ANNOUNCE_READY: {
        id: 'ANNOUNCE_READY',
        label: 'Announce Ready',
        emoji: '📣',
        color: 'warning',
        description: 'Announce audio is ready - awaiting script generation',
        isProcessing: false,
        isFinal: false,
    },
    SCRIPT_READY: {
        id: 'SCRIPT_READY',
        label: 'Script Ready',
        emoji: '📜',
        color: 'warning',
        description: 'Script is ready for TTS generation',
        isProcessing: false,
        isFinal: false,
    },
    TTS_READY: {
        id: 'TTS_READY',
        label: 'TTS Ready',
        emoji: '🗣️',
        color: 'warning',
        description: 'TTS audio has been generated - ready for mixing',
        isProcessing: false,
        isFinal: false,
    },
    AUDIO_READY: {
        id: 'AUDIO_READY',
        label: 'Audio Ready',
        emoji: '🎧',
        color: 'warning',
        description: 'Audio mixing complete - ready for external audio generation',
        isProcessing: false,
        isFinal: false,
    },
    EXTERNAL_AUDIO_READY: {
        id: 'EXTERNAL_AUDIO_READY',
        label: 'External Audio Ready',
        emoji: '🔈',
        color: 'warning',
        description: 'External audio is ready - ready for pre-publish checks',
        isProcessing: false,
        isFinal: false,
    },
    READY_FOR_PUBLISH: {
        id: 'READY_FOR_PUBLISH',
        label: 'Ready',
        emoji: '🟢',
        color: 'success',
        description: 'Pre-publish checks passed - ready to publish',
        isProcessing: false,
        isFinal: false,
    },
    SCHEDULED: {
        id: 'SCHEDULED',
        label: 'Scheduled',
        emoji: '🕓',
        color: 'success',
        description: 'Story scheduled for publication - waiting for cron to go live',
        isProcessing: false,
        isFinal: false,
        isReleased: true,
    },
    PUBLISHED: {
        id: 'PUBLISHED',
        label: 'Published',
        emoji: '🔥',
        color: 'error',
        description: 'Story is live and available to listeners',
        isProcessing: false,
        isFinal: true,
        isReleased: true,
    },
};
export function getStoryTransPhaseConfig(phase) {
    return STORY_TRANS_PHASE_CONFIG[phase];
}
export const STORY_PHASE_CONFIG = {
    META_READY: {
        id: 'META_READY',
        label: 'Meta Ready',
        emoji: '🌱',
        color: 'warning',
        description: 'Story metadata is ready - awaiting outline generation',
        isProcessing: false,
        isFinal: false,
    },
    OUTLINE_READY: {
        id: 'OUTLINE_READY',
        label: 'Outline Ready',
        emoji: '📐',
        color: 'warning',
        description: 'Story outline is ready - awaiting embedding generation',
        isProcessing: false,
        isFinal: false,
    },
    EMBEDDING_READY: {
        id: 'EMBEDDING_READY',
        label: 'Embedding Ready',
        emoji: '🧮',
        color: 'warning',
        description: 'Story embedding is ready - awaiting image generation',
        isProcessing: false,
        isFinal: false,
    },
    READY: {
        id: 'READY',
        label: 'Ready',
        emoji: '✅',
        color: 'success',
        description: 'Story is ready - image generated, ready for translations',
        isProcessing: false,
        isFinal: true,
    },
};
export const SHOW_PHASES = ['DRAFT', 'ACTIVE', 'ARCHIVED'];
export const LIFECYCLE_CONFIGS = {
    story: {
        entityType: 'story',
        phases: Object.keys(STORY_PHASE_CONFIG),
        rules: generateRulesFromPipeline(STORY_PIPELINE),
    },
    story_trans: {
        entityType: 'story_trans',
        phases: Object.keys(STORY_TRANS_PHASE_CONFIG),
        rules: generateRulesFromPipeline(STORY_TRANS_PIPELINE),
    },
    show: {
        entityType: 'show',
        phases: [...SHOW_PHASES],
        rules: [],
    },
};
//# sourceMappingURL=lifecycle.js.map